"use client"
import { useState } from 'react'
import { PlayerdevelopmentLanding } from './playerdevelopmentLanding';
import AthletePerformance from './AthletePerformance';
import CoachDashboard from './CoachDashboard';
import { useTheme } from '../utils/theme';

export function PlayerDevelopment() {
  const { theme } = useTheme();
  const isDarkMode = true; // OLED: always dark
  const [currentView, setCurrentView] = useState('landing');

  const handleNavigate = (view) => {
    setCurrentView(view);
  };

  const handleBackToHome = () => {
    setCurrentView('landing');
  };

  const NavigationBar = () => (
    <div className={`backdrop-blur-sm z-50 transition-colors duration-200 ${'bg-gray-800 bg-opacity-90'}`}>
      <div className="mx-auto px-4 py-3 flex items-center justify-between">
        <button
          onClick={handleBackToHome}
          className="flex items-center gap-2 text-white hover:text-white/80 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Back to Home
        </button>
        <div className="text-sm text-white">
          {currentView === 'athlete' && 'Athlete Performance Dashboard'}
          {currentView === 'coach' && 'Coach Dashboard'}
        </div>
      </div>
    </div>
  );

  return (
    <div className={`transition-colors duration-200 ${'bg-[#0a0a0a] text-white'}`}>
      {currentView !== 'landing' && <NavigationBar />}
      <div className={currentView !== 'landing' ? 'pt-14' : ''}>
        {currentView === 'landing' && <PlayerdevelopmentLanding onNavigate={handleNavigate} />}
        {currentView === 'athlete' && <AthletePerformance />}
        {currentView === 'coach' && <CoachDashboard />}
      </div>
    </div>
  )
}